const readMore = (
    $el,
    {
        maxHeight,
        speed = 200,
        moreLink = '<a>Read more</a>',
        lessLink = '<a>Close</a>',
        spaceForMoreLink = 20,
        keepScrollPosition = true
    }
) => {
    if ($el.data('readmore')) {
        return;
    }
    $el.data('readmore', true);

    const maxHeightOuter = maxHeight + spaceForMoreLink;
    const expandedHeight = 1000;

    const $contentWrapper = $('<div class="js-readmore-wrapper">');
    const $moreLink = $(moreLink);
    const $lessLink = $(lessLink);
    let $content;
    let previoiusScrollPosition;

    const init = () => {
        $lessLink.hide();

        $contentWrapper.css({
            maxHeight,
            overflow: 'hidden',
            transition: 'maxHeight 1s'
        });

        $el.css({
            maxHeight: maxHeightOuter,
            overflow: 'hidden',
            position: 'relative',
            paddingBottom: spaceForMoreLink,
            transition: 'maxHeight 1s'
        });

        $moreLink.css({
            position: 'absolute',
            top: maxHeight
        });

        $moreLink.on('click', expand);
        $lessLink.on('click', collapse);
    };

    const render = () => {
        $el.addClass('js-readmore');
        $el.wrapInner($contentWrapper);
        $content = $el.contents();
        $el.append($moreLink);
        $el.append($lessLink);
    };

    const saveScrollPosition = () => {
        const bodyScrollTop = $('body').scrollTop();
        previoiusScrollPosition = $el.offset().top - bodyScrollTop;
    };
    const restoreScrollPosition = () => {
        const bodyScrollTop = $('body').scrollTop();
        const currentScrollPosition = $el.offset().top - bodyScrollTop;
        const scrollLength = currentScrollPosition - previoiusScrollPosition;
        $('body').animate({ scrollTop: `+=${scrollLength}` }, speed);
    };

    const expand = () => {
        keepScrollPosition && saveScrollPosition();
        $moreLink.hide();
        $lessLink.show();

        $el.animate({ maxHeight: expandedHeight }, speed);
        $content.animate({ maxHeight: expandedHeight }, speed);
    };

    const collapse = () => {
        $el.animate({ maxHeight: maxHeightOuter }, speed);
        keepScrollPosition && restoreScrollPosition();
        $content.animate({ maxHeight }, speed, () => {
            $moreLink.show();
            $lessLink.hide();
        });
    };

    init();
    render();
};

export default readMore;
